//
// A11Y: Text
//

let a11yText = {
    'next' : 'Show next slide',
    'prev' : 'Show previous slide',
    'lightboxPrev' : 'Show previous image',
    'lightboxNext': 'Show next image',
    'lightboxClose': 'Close lightbox',
    'paginationBulletMessage': 'Go to slide {{index}}',
};

if(document.getElementsByTagName('html')[0].getAttribute('lang') === 'de'){
    a11yText = {
        'next' : 'Nächsten Slide anzeigen',
        'prev' : 'Vorherigen Slide anzeigen',
        'lightboxPrev' : 'Vorheriges Bild anzeigen',
        'lightboxNext': 'Nächstes Bild anzeigen',
        'lightboxClose': 'Gallerie schließen',
        'paginationBulletMessage': 'Zeige Inhalt {{index}}',
    };
}

export {
    a11yText,
};
